import { Loader2 } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { projectId, publicAnonKey } from '../../utils/supabase/info';
import { api } from '../../shared/api/client';

const SERVER_URL = `https://${projectId}.supabase.co/functions/v1/make-server-bde4f709`;

export default function OAuthCallbackPage() {
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;

    const handleCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const state = params.get('state');
      const error = params.get('error');
      const errorDescription = params.get('error_description');

      console.log('🔄 OAuth callback loaded, state:', state, 'has code:', !!code);

      // Ошибка от Instagram/Facebook
      if (error) {
        if (window.opener) {
          window.opener.postMessage(
            { type: 'instagram_oauth_error', error: errorDescription || error },
            window.location.origin
          );
          window.close();
        } else {
          localStorage.setItem('fb_oauth_result', JSON.stringify({ error: errorDescription || error }));
          window.location.href = '/accounts';
        }
        return;
      }

      if (!code) return;

      // Instagram OAuth — popup flow (state=instagram)
      if (state === 'instagram') {
        console.log('✅ Instagram OAuth code received, sending to parent window');
        if (window.opener) {
          // '*' because the opener may be on a different domain (test vs prod).
          // The parent validates event.origin before processing.
          window.opener.postMessage(
            { type: 'instagram_oauth_code', code },
            '*'
          );
          window.close();
        }
        return;
      }

      // Facebook OAuth — существующий redirect flow
      try {
        console.log('🔄 Facebook OAuth callback, exchanging code...');

        let accountId: string;
        try {
          const stateData = JSON.parse(state || '{}');
          accountId = stateData.accountId;
        } catch {
          accountId = localStorage.getItem('fb_connect_account_id') || '';
        }

        if (!accountId) throw new Error('No account ID found');

        const redirectUri = window.location.origin + '/oauth/callback';

        const callbackResponse = await fetch(`${SERVER_URL}/facebook-oauth/callback`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${publicAnonKey}`,
          },
          body: JSON.stringify({ code, redirectUri }),
        });

        if (!callbackResponse.ok) {
          const err = await callbackResponse.json();
          throw new Error(err.error || 'Failed to exchange code');
        }

        const { accessToken, userId, userName } = await callbackResponse.json();

        console.log('✅ Facebook token obtained, saving...');

        // Сохраняем FB-токен в аккаунт через api-клиент (user JWT).
        // Роут /accounts/:id защищён — анонимный ключ давал 401.
        await api.patch(`/accounts/${accountId}`, {
          facebookAccessToken: accessToken,
          facebookUserId: userId,
          facebookUserName: userName,
        });

        localStorage.setItem('fb_oauth_result', JSON.stringify({
          success: true,
          message: 'Facebook успешно подключен!',
        }));

        console.log('🔄 Redirecting to /accounts...');
        window.location.href = '/accounts';
      } catch (err) {
        console.error('❌ Facebook OAuth error:', err);
        localStorage.setItem('fb_oauth_result', JSON.stringify({
          error: err instanceof Error ? err.message : 'OAuth failed',
        }));
        setTimeout(() => { window.location.href = '/accounts'; }, 2000);
      }
    };

    handleCallback();
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="flex flex-col items-center gap-3 text-center">
        <Loader2 className="size-8 animate-spin text-muted-foreground" />
        <p>Обработка авторизации…</p>
      </div>
    </div>
  );
}
